export interface IThreshold {
    low: number;
    high: number;
    enabled: boolean;
}

export const compareThreshold = (a: IThreshold, b: IThreshold): boolean => {
    return a.low !== b.low || a.high !== b.high || a.enabled !== b.enabled;
};
